export default {
    en: {
        tab: {
            exhibition: 'Exhibition',
            tbd: 'Exhibition(TBD)',
        },

        list: {
            ancmAcpsDvsCd: 'Classification of Exhibition and Work Presentation',
            ancmNm: 'Title',
            issueDt: 'Date of Presentation',
        },

        detail: {
            ancmNtnCd: 'Country',
            ancmNtnIo: 'Domestic/International',
            ancmNm: 'Title',
            ancmAcpsDvsCd: 'Classification',
            creditNum: 'Points',
            creditNumDesc: 'Points can be from {from} to {to}.',
            creditRequestNum: 'Request for Extra-Credit',
            creditRequestNumDesc: 'Extra-credit is awarded following application, review by department/college (Graduate School) Personal committee and final approval of Faculty Personnel committee for international achievements.',
            ancmDt: 'Period',
            ancmPlcNm: 'Country/Venue',
            planNmgCrpNm: 'Host Institution',
            issueOrg: 'Publisher',
            roleCd: 'Role',
            score: 'Points',

            exhibition: {
                issueDt: 'Date',
            },

            tbd: {
                issueDt: 'Date(TBD)',
            },

            // exhibitGradeN: '선택안함',
            exhibitGradeA: 'Tier 1',
            exhibitGradeB: 'Tier 2',
            exhibitGradeC: 'Tier 3',
            exhibitGradeD: 'Tier 4',
        }
    },
    ko: {
        tab: {
            exhibition: '전시/작품발표',
            tbd: '전시/작품발표(예정)',
        },

        list: {
            ancmAcpsDvsCd: '전시 및 작품발표 구분',
            ancmNm: '제목',
            issueDt: '발표년월',
        },

        detail: {
            ancmNtnCd: '발표국가',
            ancmNtnIo: '국내/국제',
            ancmNm: '제목',
            ancmAcpsDvsCd: '구분',
            creditNum: '부과점수',
            creditNumDesc: '점수는 {from} ~ {to}까지 부과 가능합니다.',
            creditRequestNum: '가산점 부과신청',
            creditRequestNumDesc: '세칙 제36조 제2항: 국제적인 창작활동의 경우 소속대학(원) 인사위원회는 심사를 거쳐 국내 기준점수 대비 100%의 가산점을 부여할 수 있습니다.',
            ancmDt: '기간',
            ancmPlcNm: '장소',
            planNmgCrpNm: '주최기관',
            issueOrg: '발행기관/출판사',
            roleCd: '참여구분',
            score: '최종점수',

            exhibition: {
                issueDt: '발표년월',
            },

            tbd: {
                issueDt: '발표예정년월',
            },

            // exhibitGradeN: '선택안함',
            exhibitGradeA: '1등급',
            exhibitGradeB: '2등급',
            exhibitGradeC: '3등급',
            exhibitGradeD: '4등급',
        }
    }
}